import { render, staticRenderFns } from "./UpIcon.vue?vue&type=template&id=e6a32298"
import script from "./UpIcon.vue?vue&type=script&lang=js"
export * from "./UpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports